"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FramelessBridge_1 = require("./FramelessBridge");
var HostType_1 = require("../interfaces/HostType");
var ClientBridgeFactory = /** @class */ (function () {
    function ClientBridgeFactory() {
    }
    ClientBridgeFactory.getClientBridge = function (protocolInfo) {
        switch (protocolInfo.hostType) {
            case HostType_1.default.IFrame:
                throw new Error("Framed bridge not implemented for " + protocolInfo.hostType + " in IC3Core");
            case HostType_1.default.Page:
                return new FramelessBridge_1.default(protocolInfo.protocolType);
            default:
                throw new Error("Client bridge not implemented for " + protocolInfo.hostType + " in IC3Core");
        }
    };
    return ClientBridgeFactory;
}());
exports.default = ClientBridgeFactory;
//# sourceMappingURL=ClientBridgeFactory.js.map